@if (renderItem()) {
    <ng-template option />
} @else {
    <app-select-option
        (mouseEnter)="mouseEnter.emit()"
        (mouseLeave)="mouseLeave.emit()"
        [option]="option()"
        [bindLabel]="bindLabel()!"
        [bindValue]="bindValue()!"
        [focus]="focus()"
        [renderItem]="renderItem()"
        [active]="active()"
    />
}
